import { render, staticRenderFns } from "./RTProjectCover.vue?vue&type=template&id=477e5fb4&scoped=true&"
import script from "./RTProjectCover.vue?vue&type=script&lang=js&"
export * from "./RTProjectCover.vue?vue&type=script&lang=js&"
import style0 from "./RTProjectCover.vue?vue&type=style&index=0&id=477e5fb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477e5fb4",
  null
  
)

export default component.exports